/**
 * Grythyttan shows outdoor furniture in its own environment, so upstream's
 * generated room is switched off: no room is built, the room button is hidden
 * and saved designs carry no `room` field.
 */
export const generatedRoomEnabled = false;
